export enum ButtonState {
  GET_UPDATE = 'getUpdate',
  PROVIDE_ID = 'provideId',
  VERIFY_ACCOUNT = 'verifyAccount',
  VERIFY_IDENTITY = 'verifyIdentity',
  VERIFYING_ACCOUNT = 'verifyingAccount',
  RETRY_VERIFICATION = 'retryVerification',
  CONTACT_SUPPORT = 'contactSupport',
  DEPOSIT = 'deposit',
}
